window.P23DTF_PRINT_ASSIGNMENTS = {
  "aruba-t-shirt-lady-sportarbl": "tshirt_sleeveless_coords_5",
  "aruba-t-shirt-man-sportarbm": "tshirt_sleeveless_coords_5",
  "aruba-tsularb": "tshirt_sleeveless_coords_5",
  "beach-unisex-tsualbch": "tshirt_sleeveless_coords_5",
  "camiseta-manga-corta-5010": "tshirt_sleeve_coords_4_velilla",
  "camiseta-over-boxy": "tshirt_sleeve_coords_2",
  "camiseta-over-relaxed-fit": "tshirt_sleeve_coords_2",
  "camiseta-regular-premium": "tshirt_sleeve_coords_2",
  "camiseta-regular-premium-king-size": "tshirt_sleeve_coords_1",
  "camiseta-regular-premium-lady": "tshirt_rotated_sleeve_coords_6",
  "camiseta-sport": "tshirt_sleeve_coords_3",
  "camiseta-sport-lady": "tshirt_rotated_sleeve_coords_6",
  "camiseta-tecnica-105506": "tshirt_sleeve_coords_4_velilla",
  "camiseta-tecnica-bicolor-105501": "tshirt_sleeve_coords_4_velilla",
  "camiseta-tecnica-grs-v-dynamix-105635": "tshirt_sleeve_coords_4_velilla",
  "camiseta-tecnica-jaspeada-105507": "tshirt_sleeve_coords_4_velilla",
  "camiseta-urban-oversize": "tshirt_sleeve_coords_2",
  "curves-lady-t-shirt-curvs150": "tshirt_sleeve_coords_1",
  "curves-polo-queen-size-curvspolo": "polo_sleeve_coords_1",
  "curves-t-shirt-v-neck-curvspico": "tshirt_sleeve_coords_1",
  "heavy-pique-polo-lady-spheavyldy": "polo_sleeve_coords_1",
  "ibiza-tsulibiza": "tshirt_sleeveless_coords_5",
  "jt150-jt150": "tshirt_sleeve_coords_1",
  "lady-regular-comfort-v-neck-tsrlcmfp": "tshirt_rotated_sleeve_coords_6",
  "maldivas-tsulmldv": "tshirt_rotated_sleeve_coords_6",
  "maliatsulmalia": "tshirt_sleeveless_coords_5",
  "man-urban-tank-top-tsuatnk": "tshirt_sleeveless_coords_5",
  "papua-tsulpapls": "tshirt_rotated_sleeve_coords_6",
  "pique-polo-lady-sportpqlady": "polo_sleeve_coords_3",
  "pique-polo-man-sportpique": "polo_sleeve_coords_1",
  "polo-manga-cortajtpolo": "polo_sleeve_coords_1",
  "polo-premium-pora240": "polo_sleeve_coords_1",
  "polo-worker-210-pora210wk": "polo_sleeve_coords_1",
  "polo-worker-lady-popl200wk": "polo_sleeve_coords_2",
  "regular-combed-t-shirt-tsr160comb": "tshirt_sleeve_coords_1",
  "regular-comfort-lady-tsrlcmf": "tshirt_rotated_sleeve_coords_6",
  "regular-comfort-ls-lady-tsrlcmfls": "tshirt_rotated_sleeve_coords_6",
  "regular-hit-t-shirt-ls-tsra170ls": "tshirt_sleeve_coords_2",
  "regular-hit-t-shirt-tsra170": "tshirt_sleeve_coords_1",
  "regular-ls-t-shirt-tsra150ls": "tshirt_sleeve_coords_2",
  "regular-organic-t-shirt-tsr160org": "tshirt_sleeve_coords_1",
  "regular-polo-lady-popl200": "polo_sleeve_coords_2",
  "regular-polo-ls-lady-popl200ls": "polo_sleeve_coords_1",
  "regular-polo-ls-pora210ls": "polo_sleeve_coords_1",
  "regular-polo-man-pora210": "polo_sleeve_coords_3",
  "regular-polo-man-wash-pora210": "polo_sleeve_coords_4",
  "regular-premium-ls-lady-tsrlprmls": "tshirt_sleeve_coords_2",
  "regular-t-shirt-man-tsra150": "tshirt_sleeve_coords_1",
  "saona-tsulsaona": "tshirt_sleeveless_coords_5",
  "sea-lady-tslsea": "tshirt_rotated_sleeve_coords_6",
  "sea-man-tssea": "tshirt_sleeve_coords_1",
  "sicilia-tsulscl": "tshirt_rotated_sleeve_coords_6",
  "slub-lady-tsulslb": "tshirt_rotated_sleeve_coords_6",
  "sport-contrast-sportctrm": "tshirt_sleeve_coords_1",
  "sport-man-ls-sportmanls": "tshirt_sleeve_coords_3",
  "sport-regular-sportrglm": "tshirt_sleeve_coords_1",
  "strap-tsuastrpm": "tshirt_sleeveless_coords_5",
  "super-t-ts150st": "tshirt_sleeve_coords_1",
  "tobago-tsultbg": "tshirt_sleeveless_coords_5",
  "urban-t-shirt-tsua150": "tshirt_sleeve_coords_1",
  "urban-v-neck-tsuapico": "tshirt_sleeve_coords_1",
  "victoria-tsulvctr": "tshirt_sleeveless_coords_5",
};

window.P23DTF_PRINT_PRODUCT_MAPS = window.P23DTF_PRINT_PRODUCT_MAPS || {};
window.P23DTF_PRINT_REFERENCE_ASSIGNMENTS = window.P23DTF_PRINT_REFERENCE_ASSIGNMENTS || {};
window.P23DTF_PRINT_REFERENCE_MAPS = window.P23DTF_PRINT_REFERENCE_MAPS || {};


window.P23DTF_PRINT_GROUP_MAPS = window.P23DTF_PRINT_GROUP_MAPS || {
  "tshirt_sleeve_coords_1": {
    "label": "Camiseta Manga Coordenadas 1",
    "kind": "tshirt",
    "notes": "Camisetas estándar. Zonas activas por ahora: frontal, trasera y mangas.",
    "zones": {
      "left_sleeve_outer": {
        "rect": {
          "x": 185,
          "y": 99,
          "w": 82,
          "h": 109
        },
        "rotation": 0,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "right_sleeve_outer": {
        "rect": {
          "x": 113,
          "y": 99,
          "w": 82,
          "h": 109
        },
        "rotation": 0,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "front_full": {
        "rect": {
          "x": 100,
          "y": 82,
          "w": 180,
          "h": 205
        },
        "rotation": 0,
        "printCm": {
          "w": 30,
          "h": 35
        }
      },
      "back_full": {
        "rect": {
          "x": 100,
          "y": 76,
          "w": 180,
          "h": 215
        },
        "rotation": 0,
        "printCm": {
          "w": 30,
          "h": 35
        }
      }
    }
  },
  "tshirt_sleeve_coords_2": {
    "label": "Camiseta Manga Coordenadas 2",
    "kind": "tshirt",
    "notes": "Oversize/relaxed/manga larga premium. Zonas activas por ahora: frontal, trasera y mangas.",
    "zones": {
      "left_sleeve_outer": {
        "rect": {
          "x": 185,
          "y": 99,
          "w": 82,
          "h": 109
        },
        "rotation": 0,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "right_sleeve_outer": {
        "rect": {
          "x": 113,
          "y": 99,
          "w": 82,
          "h": 109
        },
        "rotation": 0,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "front_full": {
        "rect": {
          "x": 100,
          "y": 82,
          "w": 180,
          "h": 205
        },
        "rotation": 0,
        "printCm": {
          "w": 30,
          "h": 35
        }
      },
      "back_full": {
        "rect": {
          "x": 100,
          "y": 76,
          "w": 180,
          "h": 215
        },
        "rotation": 0,
        "printCm": {
          "w": 30,
          "h": 35
        }
      }
    }
  },
  "tshirt_sleeve_coords_3": {
    "label": "Camiseta Manga Coordenadas 3",
    "kind": "sport_tshirt",
    "notes": "Sport.",
    "zones": {
      "left_sleeve_outer": {
        "rect": {
          "x": 50,
          "y": 126,
          "w": 72,
          "h": 142
        },
        "rotation": 0,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "right_sleeve_outer": {
        "rect": {
          "x": 258,
          "y": 126,
          "w": 72,
          "h": 142
        },
        "rotation": 0,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "front_full": {
        "rect": {
          "x": 84,
          "y": 68,
          "w": 212,
          "h": 250
        },
        "rotation": 0,
        "printCm": {
          "w": 30,
          "h": 35
        }
      },
      "left_chest": {
        "rect": {
          "x": 116,
          "y": 92,
          "w": 78,
          "h": 78
        },
        "rotation": 0,
        "printCm": {
          "w": 10,
          "h": 10
        }
      },
      "back_full": {
        "rect": {
          "x": 84,
          "y": 68,
          "w": 212,
          "h": 250
        },
        "rotation": 0,
        "printCm": {
          "w": 30,
          "h": 35
        }
      }
    }
  },
  "tshirt_sleeve_coords_4_velilla": {
    "label": "Camiseta Manga Coordenadas 4 Velilla",
    "kind": "technical_tshirt",
    "notes": "Técnicas Velilla.",
    "zones": {
      "left_sleeve_outer": {
        "rect": {
          "x": 52,
          "y": 118,
          "w": 68,
          "h": 136
        },
        "rotation": -2,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "right_sleeve_outer": {
        "rect": {
          "x": 260,
          "y": 118,
          "w": 68,
          "h": 136
        },
        "rotation": 2,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "front_full": {
        "rect": {
          "x": 86,
          "y": 70,
          "w": 208,
          "h": 248
        },
        "rotation": 0,
        "printCm": {
          "w": 30,
          "h": 35
        }
      },
      "left_chest": {
        "rect": {
          "x": 118,
          "y": 94,
          "w": 76,
          "h": 76
        },
        "rotation": 0,
        "printCm": {
          "w": 10,
          "h": 10
        }
      },
      "back_full": {
        "rect": {
          "x": 86,
          "y": 70,
          "w": 208,
          "h": 248
        },
        "rotation": 0,
        "printCm": {
          "w": 30,
          "h": 35
        }
      }
    }
  },
  "tshirt_sleeveless_coords_5": {
    "label": "Camiseta Sin mangas Coordenadas 5",
    "kind": "sleeveless_tshirt",
    "notes": "Sin mangas/tirantes. Sin zona manga exterior por defecto.",
    "zones": {
      "front_full": {
        "rect": {
          "x": 90,
          "y": 72,
          "w": 200,
          "h": 252
        },
        "rotation": 0,
        "printCm": {
          "w": 28,
          "h": 34
        }
      },
      "left_chest": {
        "rect": {
          "x": 118,
          "y": 96,
          "w": 72,
          "h": 72
        },
        "rotation": 0,
        "printCm": {
          "w": 10,
          "h": 10
        }
      },
      "back_full": {
        "rect": {
          "x": 90,
          "y": 72,
          "w": 200,
          "h": 252
        },
        "rotation": 0,
        "printCm": {
          "w": 28,
          "h": 34
        }
      }
    }
  },
  "tshirt_rotated_sleeve_coords_6": {
    "label": "Camiseta Mangas Giradas Coordenadas 6",
    "kind": "rotated_tshirt",
    "notes": "Mangas en perspectiva/giradas.",
    "zones": {
      "left_sleeve_outer": {
        "rect": {
          "x": 38,
          "y": 110,
          "w": 82,
          "h": 136
        },
        "rotation": -14,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "right_sleeve_outer": {
        "rect": {
          "x": 260,
          "y": 110,
          "w": 82,
          "h": 136
        },
        "rotation": 14,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "front_full": {
        "rect": {
          "x": 86,
          "y": 72,
          "w": 208,
          "h": 246
        },
        "rotation": 0,
        "printCm": {
          "w": 30,
          "h": 35
        }
      },
      "left_chest": {
        "rect": {
          "x": 116,
          "y": 96,
          "w": 78,
          "h": 78
        },
        "rotation": 0,
        "printCm": {
          "w": 10,
          "h": 10
        }
      },
      "back_full": {
        "rect": {
          "x": 86,
          "y": 72,
          "w": 208,
          "h": 246
        },
        "rotation": 0,
        "printCm": {
          "w": 30,
          "h": 35
        }
      }
    }
  },
  "polo_sleeve_coords_1": {
    "label": "Polos Manga Coordenadas 1",
    "kind": "polo",
    "notes": "Polos estándar.",
    "zones": {
      "left_sleeve_outer": {
        "rect": {
          "x": 48,
          "y": 126,
          "w": 74,
          "h": 138
        },
        "rotation": -2,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "right_sleeve_outer": {
        "rect": {
          "x": 258,
          "y": 126,
          "w": 74,
          "h": 138
        },
        "rotation": 2,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "front_full": {
        "rect": {
          "x": 88,
          "y": 82,
          "w": 204,
          "h": 230
        },
        "rotation": 0,
        "printCm": {
          "w": 28,
          "h": 32
        }
      },
      "left_chest": {
        "rect": {
          "x": 116,
          "y": 108,
          "w": 76,
          "h": 76
        },
        "rotation": 0,
        "printCm": {
          "w": 10,
          "h": 10
        }
      },
      "back_full": {
        "rect": {
          "x": 88,
          "y": 82,
          "w": 204,
          "h": 230
        },
        "rotation": 0,
        "printCm": {
          "w": 28,
          "h": 32
        }
      }
    }
  },
  "polo_sleeve_coords_2": {
    "label": "Polos Manga Coordenadas 2",
    "kind": "polo_lady",
    "notes": "Polos lady/worker lady.",
    "zones": {
      "left_sleeve_outer": {
        "rect": {
          "x": 52,
          "y": 128,
          "w": 68,
          "h": 132
        },
        "rotation": -4,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "right_sleeve_outer": {
        "rect": {
          "x": 260,
          "y": 128,
          "w": 68,
          "h": 132
        },
        "rotation": 4,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "front_full": {
        "rect": {
          "x": 92,
          "y": 84,
          "w": 196,
          "h": 228
        },
        "rotation": 0,
        "printCm": {
          "w": 28,
          "h": 32
        }
      },
      "left_chest": {
        "rect": {
          "x": 118,
          "y": 110,
          "w": 72,
          "h": 72
        },
        "rotation": 0,
        "printCm": {
          "w": 10,
          "h": 10
        }
      },
      "back_full": {
        "rect": {
          "x": 92,
          "y": 84,
          "w": 196,
          "h": 228
        },
        "rotation": 0,
        "printCm": {
          "w": 28,
          "h": 32
        }
      }
    }
  },
  "polo_sleeve_coords_3": {
    "label": "Polos Manga Coordenada 3",
    "kind": "polo_pique",
    "notes": "Pique/regular polo man.",
    "zones": {
      "left_sleeve_outer": {
        "rect": {
          "x": 46,
          "y": 122,
          "w": 76,
          "h": 142
        },
        "rotation": -3,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "right_sleeve_outer": {
        "rect": {
          "x": 258,
          "y": 122,
          "w": 76,
          "h": 142
        },
        "rotation": 3,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "front_full": {
        "rect": {
          "x": 88,
          "y": 80,
          "w": 206,
          "h": 232
        },
        "rotation": 0,
        "printCm": {
          "w": 28,
          "h": 32
        }
      },
      "left_chest": {
        "rect": {
          "x": 116,
          "y": 106,
          "w": 76,
          "h": 76
        },
        "rotation": 0,
        "printCm": {
          "w": 10,
          "h": 10
        }
      },
      "back_full": {
        "rect": {
          "x": 88,
          "y": 80,
          "w": 206,
          "h": 232
        },
        "rotation": 0,
        "printCm": {
          "w": 28,
          "h": 32
        }
      }
    }
  },
  "polo_sleeve_coords_4": {
    "label": "Polos Manga Coordenadas 4",
    "kind": "polo_wash",
    "notes": "Regular Polo Man WASH.",
    "zones": {
      "left_sleeve_outer": {
        "rect": {
          "x": 50,
          "y": 124,
          "w": 72,
          "h": 138
        },
        "rotation": -5,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "right_sleeve_outer": {
        "rect": {
          "x": 258,
          "y": 124,
          "w": 72,
          "h": 138
        },
        "rotation": 5,
        "printCm": {
          "w": 8,
          "h": 12
        }
      },
      "front_full": {
        "rect": {
          "x": 88,
          "y": 82,
          "w": 204,
          "h": 230
        },
        "rotation": 0,
        "printCm": {
          "w": 28,
          "h": 32
        }
      },
      "left_chest": {
        "rect": {
          "x": 116,
          "y": 108,
          "w": 76,
          "h": 76
        },
        "rotation": 0,
        "printCm": {
          "w": 10,
          "h": 10
        }
      },
      "back_full": {
        "rect": {
          "x": 88,
          "y": 82,
          "w": 204,
          "h": 230
        },
        "rotation": 0,
        "printCm": {
          "w": 28,
          "h": 32
        }
      }
    }
  }
};

(function () {
  "use strict";

  const DEFAULT_GROUP = "tshirt_sleeve_coords_1";

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function normalizeKey(value) {
    return String(value || "").trim().toUpperCase();
  }

  function normalizeHandle(value) {
    return String(value || "").trim().toLowerCase();
  }

  function getProductKey(handle, reference) {
    const ref = normalizeKey(reference);
    if (ref) return ref;
    return normalizeHandle(handle || getProductHandleFromLocation());
  }

  function getProductHandleFromLocation() {
    const match = String(window.location.pathname || "").match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]).toLowerCase() : "";
  }

  function getGroupIdForHandle(handle, reference) {
    const ref = normalizeKey(reference);
    if (ref && (window.P23DTF_PRINT_REFERENCE_ASSIGNMENTS || {})[ref]) {
      return (window.P23DTF_PRINT_REFERENCE_ASSIGNMENTS || {})[ref];
    }

    const key = normalizeHandle(handle || getProductHandleFromLocation());
    return (window.P23DTF_PRINT_ASSIGNMENTS || {})[key] || DEFAULT_GROUP;
  }

  function getGroupMap(groupId) {
    const maps = window.P23DTF_PRINT_GROUP_MAPS || {};
    const map = maps[groupId] || maps[DEFAULT_GROUP] || null;
    return map ? clone(map) : null;
  }

  function getProductMap(handle, reference) {
    const ref = normalizeKey(reference);
    const key = ref || normalizeHandle(handle || getProductHandleFromLocation());

    const referenceMap = ref ? (window.P23DTF_PRINT_REFERENCE_MAPS || {})[ref] : null;
    if (referenceMap) return clone(referenceMap);

    const productMap = (window.P23DTF_PRINT_PRODUCT_MAPS || {})[key];
    return productMap ? clone(productMap) : null;
  }

  function getZoneMap(zoneId, handle, reference, manufacturer) {
    const productMap = getProductMap(handle, reference);
    if (productMap && productMap.zones && productMap.zones[zoneId]) {
      return clone(productMap.zones[zoneId]);
    }

    const groupId = getGroupIdForHandle(handle, reference);
    const groupMap = getGroupMap(groupId);
    if (!groupMap || !groupMap.zones) return null;
    const zone = groupMap.zones[zoneId];
    return zone ? clone(zone) : null;
  }

  function getCurrentProductPrintMap(handleArg, referenceArg, manufacturerArg) {
    const handle = normalizeHandle(handleArg || getProductHandleFromLocation());
    const reference = normalizeKey(referenceArg);
    const manufacturer = normalizeKey(manufacturerArg);
    const productKey = getProductKey(handle, reference);
    const productMap = getProductMap(handle, reference);
    const groupId = getGroupIdForHandle(handle, reference);
    const groupMap = getGroupMap(groupId);

    return {
      handle,
      reference,
      manufacturer,
      productKey,
      groupId,
      productMap: productMap ? clone(productMap) : null,
      groupMap: groupMap ? clone(groupMap) : null,
      mapSource: productMap ? "product" : "group"
    };
  }

  function cmForLayer(zoneMap, layerRect) {
    if (!zoneMap || !zoneMap.rect || !zoneMap.printCm || !layerRect) return null;
    const cmPerUnitX = zoneMap.printCm.w / zoneMap.rect.w;
    const cmPerUnitY = zoneMap.printCm.h / zoneMap.rect.h;
    return {
      w: Number((layerRect.w * cmPerUnitX).toFixed(2)),
      h: Number((layerRect.h * cmPerUnitY).toFixed(2))
    };
  }

  function dpiForLayer(upload, printedCm) {
    if (!upload || !printedCm || !printedCm.w || !printedCm.h) return null;
    const widthPx = Number(upload.width || upload.naturalWidth || 0);
    const heightPx = Number(upload.height || upload.naturalHeight || 0);
    if (!widthPx || !heightPx) return null;
    return Math.floor(Math.min(widthPx / (printedCm.w / 2.54), heightPx / (printedCm.h / 2.54)));
  }

  function qualityForDpi(dpi) {
    if (!dpi && dpi !== 0) return { label: "Sin datos", level: "unknown" };
    if (dpi >= 150) return { label: "Buena", level: "good" };
    if (dpi >= 100) return { label: "Aceptable", level: "ok" };
    return { label: "Baja", level: "bad" };
  }

  function updateGroupZone(groupId, zoneId, patch) {
    const maps = window.P23DTF_PRINT_GROUP_MAPS || {};
    if (!maps[groupId]) maps[groupId] = { label: groupId, zones: {} };
    if (!maps[groupId].zones) maps[groupId].zones = {};
    if (!maps[groupId].zones[zoneId]) maps[groupId].zones[zoneId] = {};
    const current = maps[groupId].zones[zoneId];
    if (patch.rect) current.rect = Object.assign({}, current.rect || {}, patch.rect);
    if (patch.printCm) current.printCm = Object.assign({}, current.printCm || {}, patch.printCm);
    if (typeof patch.rotation === "number") current.rotation = patch.rotation;
    return clone(current);
  }

  function updateProductZone(productKey, zoneId, patch) {
    const key = normalizeKey(productKey);
    const maps = window.P23DTF_PRINT_REFERENCE_MAPS || {};
    if (!maps[key]) maps[key] = { label: key, zones: {} };
    if (!maps[key].zones) maps[key].zones = {};
    if (!maps[key].zones[zoneId]) maps[key].zones[zoneId] = {};
    const current = maps[key].zones[zoneId];
    if (patch.rect) current.rect = Object.assign({}, current.rect || {}, patch.rect);
    if (patch.printCm) current.printCm = Object.assign({}, current.printCm || {}, patch.printCm);
    if (typeof patch.rotation === "number") current.rotation = patch.rotation;
    return clone(current);
  }

  function exportMaps() {
    return JSON.stringify({
      referenceMaps: window.P23DTF_PRINT_REFERENCE_MAPS || {},
      productMaps: window.P23DTF_PRINT_PRODUCT_MAPS || {},
      groupMaps: window.P23DTF_PRINT_GROUP_MAPS || {}
    }, null, 2);
  }

  function debug() {
    const current = getCurrentProductPrintMap();
    console.table([{ handle: current.handle, groupId: current.groupId, label: current.groupMap && current.groupMap.label }]);
    return current;
  }

  window.P23DTFPrintMaps = {
    defaultGroup: DEFAULT_GROUP,
    getProductHandleFromLocation,
    getGroupIdForHandle,
    getGroupMap,
    getProductMap,
    getZoneMap,
    getCurrentProductPrintMap,
    cmForLayer,
    dpiForLayer,
    qualityForDpi,
    updateGroupZone,
    updateProductZone,
    exportMaps,
    debug
  };

  console.log("[23DTF] Print maps v1 loaded", getCurrentProductPrintMap());
})();
